import { useContext, useEffect, useState } from "react";
import { Notification, useToaster } from "rsuite";
import { APIRequest, ApiUrl } from "../../../Helpers/ApiHelper";
import Header from "../../comman/Header-copy"
import CustomLoader from "../../comman/Loader/CustomLoader";
import List from "./List";
import SearchBar from "../../comman/Search/SearchBar";
import Topbar from "../../comman/Topbar"
import CampaignDetailModal from "../campaigns/CampaignDetailModal";
import { Auth } from "../../../Contexts/AuthContext";
import ListFilters from "../../comman/ListFilters";
import History from "./History";
import Footer from "../../comman/Footer";



const MyPayouts = () => {
    const toaster = useToaster();
    const { setFavoriteCounts } = useContext(Auth);
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState([]);
    const [searchData, setSearchData] = useState([]);
    const [search, setSearch] = useState('');
    const [selectedCampaign, setSelectedCampaign] = useState();
    const [showCampignDetailModal, setShowCampignDetailModal] = useState();
    const [filterStatus, setFilterStatus] = useState('payouts');
    const [filters, setFilters] = useState([]);

    useEffect(() => {
        getMyPayouts()
        const close = (e) => {
            if (e.keyCode === 27) {
                setShowCampignDetailModal(false);
            }
        }
        window.addEventListener('keydown', close)
        return () => window.removeEventListener('keydown', close)
    }, [filterStatus])



    const getMyPayouts = () => {
        let confing = {
            url: ApiUrl.getMyPayouts,
            method: 'POST',
            body: {
                status: filterStatus
            }
        }
        setIsLoading(true);
        APIRequest(
            confing,
            res => {
                setIsLoading(false);
                setData(res?.data);
                setSearchData(res?.data);
                setFilters([
                    {
                        name: 'Payouts',
                        value: 'payouts',
                        count: res?.total_campaign_trascations,
                        is_active: filterStatus === 'payouts' ? true : false,
                    },
                    {
                        name: 'Withdrwal history',
                        value: 'withdrawal_history',
                        count: res?.total_withdrawal_request_count,
                        is_active: filterStatus === 'withdrawal_history' ? true : false,
                    }

                ]);

            },

            err => {
                toaster.push(<Notification type='warning' header="Warning" >{err?.message} </Notification>, {
                    placement: 'topEnd'
                });

            }

        )
    }

    const searchOnChange = (value) => {
        const val = value.toLowerCase();
        if (filterStatus === 'payouts') {
            var finalVal = searchData?.filter((v) => (v?.campaign.campaign_title.toLowerCase()?.includes(val)));
        } else {
            finalVal = searchData?.filter((v) => (v?.status.toLowerCase()?.includes(val)));
        }

        setData(finalVal);
        setSearch(value);
    }

    // Campign Detail modal
    const markFavorite = (id) => {
        let config = {
            url: `${ApiUrl.markFavorite}/${id}`,
            method: 'GET',
            body: {}
        }
        APIRequest(
            config,
            res => {
                setFavoriteCounts(res?.total_favorite_counts);
                localStorage.setItem('favCounts', res?.total_favorite_counts);

                setSelectedCampaign({ ...selectedCampaign, is_favorite: !selectedCampaign.is_favorite })
            },

            err => {

                setIsLoading(false);
                // console.log(err);
                // alert('SERVER ERROR');
            }

        )
    }
    const onApplyForCampaign = () => {
        setShowCampignDetailModal(false);

    }

    const handleShowSocialPlatform = (range) => {
        let toggaleValue = false;
        if (range?.selected === undefined || range?.selected === false) {
            toggaleValue = true;
        }
        const updatedRange = { ...range, selected: toggaleValue };
        const updatedRangeArr = selectedCampaign?.allocatedBudget?.map(sb => sb?.soical_paltfom_id === updatedRange?.soical_paltfom_id ? updatedRange : sb);
        setSelectedCampaign({ ...selectedCampaign, allocatedBudget: updatedRangeArr });
    }
  
    console.log("ListFilters : " , ListFilters);


    return (
        <>
            <div className="min-h-[100vh]">
                <Header />
                <Topbar />
                <CustomLoader visible={isLoading} />
                <SearchBar search={search} title={'My payouts'} searchOnChange={(val) => searchOnChange(val)} />
                <ListFilters
                    filters={filters}
                    onChangeFilter={(status) => { setSelectedCampaign(); setFilterStatus(status); }}
                />
                {filterStatus === 'payouts' ? (
                    <List data={data}
                        openCampaignDetails={(item) => { setSelectedCampaign(item); setShowCampignDetailModal(true) }}
                    />
                ) : (
                    <History data={data}
                    />
                )}

                <CampaignDetailModal item={selectedCampaign}
                    markFavorite={(id) => { markFavorite(id) }}
                    showModal={showCampignDetailModal} setShowModal={() => { setShowCampignDetailModal(!showCampignDetailModal) }}
                    applyForCampaign={(item) => { onApplyForCampaign() }}
                    setShowSocialPlatform={(range) => handleShowSocialPlatform(range)}
                />

            </div>

            {/* {console.log("main : ")} */}
            <Footer colorClass="footerColor" clas="footer2" />
        </>
    );
}
export default MyPayouts;